import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.06 2.024c-1.159.17-1.897.415-2.651.88C1.6 4.635.336 8.056 1.378 11.108c.481 1.409 1.153 2.308 3.42 4.573 1.939 1.938 5.987 5.663 6.447 5.932.293.172.646.244.949.193.495-.082.508-.092 2.406-1.801a109 109 0 0 0 4.522-4.282c2.043-2.044 2.593-2.702 3.102-3.706 1.366-2.697.861-5.878-1.27-8.012-2.048-2.05-4.89-2.551-7.414-1.306a6.8 6.8 0 0 0-1.29.818l-.25.202-.33-.253c-1.2-.921-2.527-1.409-3.93-1.445a8 8 0 0 0-.68.003m1.242 2.037c.994.174 1.807.613 2.639 1.425.538.525.717.632 1.059.632.335 0 .507-.102.993-.59.871-.873 1.803-1.351 2.903-1.49 1.274-.16 2.518.288 3.557 1.282.971.928 1.48 2.05 1.534 3.38.043 1.087-.272 2.136-.92 3.064-.746 1.066-3.374 3.677-6.963 6.916-.524.473-.994.886-1.045.918-.104.064.017.161-1.419-1.137-3.443-3.111-5.87-5.525-6.686-6.651a4.91 4.91 0 0 1-.459-5.05A5.4 5.4 0 0 1 5.68 4.466c.311-.169.912-.376 1.23-.423a5.4 5.4 0 0 1 1.392.018"
    }, null, -1)
  ])))
}
export default { render: render }